var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNegativeVariation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.27234 12.8472L14.7773 12.8472L14.7773 15.8472L1.66693 15.8472L0.166927 15.8472L0.166927 14.3472L0.166929 0.666732L3.16693 0.666732L3.16693 10.7099L12.2707 1.60613L14.392 3.72745L5.27234 12.8472Z",
    fill: "#EE4C3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegativeVariation);
export default __webpack_public_path__ + "static/media/negative-variation.d04ad465959159964929b8331611d9e9.svg";
export { ForwardRef as ReactComponent };